import type { FC, ReactNode } from 'react'

import { Building2, Store, Tag } from 'lucide-react'
import { BOLT_PATH } from '@/components/brand/logo'
import QuoteForm from '@/components/landing/quote-form'

const POINTS = [
    { icon: Store, label: 'Local businesses welcome' },
    { icon: Building2, label: 'Big companies welcome' },
    { icon: Tag, label: 'Affordable, tailored pricing' }
]

const ContactSection: FC = (): ReactNode => {
    return (
        <section id='contact' aria-labelledby='contact-title' className='relative scroll-mt-16 overflow-hidden bg-volt py-20 text-ink sm:py-28'>
            <svg
                viewBox='0 0 48 100'
                aria-hidden='true'
                className='pointer-events-none absolute -right-24 top-1/2 h-[130%] -translate-y-1/2 fill-ink/6'
            >
                <path d={BOLT_PATH} />
            </svg>

            <div className='relative mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-[1fr_1.15fr] lg:gap-16 lg:px-8'>
                <div className='lg:pt-4'>
                    <p className='text-sm font-semibold uppercase tracking-[0.18em] text-ink/60'>
                        Get a quote
                    </p>
                    <h2
                        id='contact-title'
                        className='mt-4 text-balance font-heading text-4xl font-bold leading-[1.05] tracking-[-0.03em] sm:text-6xl'
                    >
                        Let's build your website.
                    </h2>
                    <p className='mt-6 max-w-md text-lg leading-relaxed text-ink/75'>
                        Tell us a little about your business and what you need. We'll get back to you with a quote that fits your budget.
                    </p>

                    <ul className='mt-10 space-y-4'>
                        {POINTS.map(({ icon: Icon, label }) => (
                            <li key={label} className='flex items-center gap-3 font-semibold'>
                                <span className='flex size-10 items-center justify-center rounded-full bg-ink text-volt'>
                                    <Icon className='size-4' aria-hidden='true' />
                                </span>
                                {label}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className='rounded-[2rem] bg-card p-6 shadow-2xl shadow-ink/20 sm:p-10'>
                    <QuoteForm />
                </div>
            </div>
        </section>
    )
}

export default ContactSection
